export const endpoints = {
  // Settings
  LOGIN: "/users/login",
  ACCOUNT: "/users/account",
  ACCOUNT_CHANGE_PASSWORD: "/users/account/change-password",
  INVITE: "/users/invite",
  USERS: "/users",
  REGISTER_EMAIL: "/auth/register/email",
  REGISTER_USER_INFO: "/auth/register/user-info",
  REGISTER_GET_INFO: "/auth/register/get-info",

  // Scenarios
  SCENARIOS: "/scenarios",
  TEMPLATES: "/scenarios/templates",
  NODES: "/nodes",

  // Credentials
  CREDENTIALS: "/credentials",
  CREDENTIALS_METADATA: "/credentials/meta",

  // Misc
  GET_UPLOAD_PRESIGNED_URL: "/assets/presigned-upload",
}
